module.exports = __webpack_public_path__ + "img/cuenta_verificada.7e9b4a83.svg";